import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './pages/home';
import ContactPage from './pages/contact';
import BreakdownPage from './pages/breakdown';

import Navbar from './components/navbar';
import Footer from './components/footer';

import './App.css';

function App() {
  return (
    <Router>
      <div className="bg-white font-sans text-black w-screen min-h-screen flex flex-col overflow-x-hidden">

        <Navbar />

        {/* Main content grows to fill space */}
        <main className="flex-grow flex flex-col bg-gray-100">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<div>404 - Page not found</div>} />
            <Route path="/breakdown" element={<BreakdownPage />} />
          </Routes>
        </main>

        {/* Footer stays at bottom */}
        <Footer />

      </div>
    </Router>
  );
}

export default App;
